import { useState } from 'react';
import toast from 'react-hot-toast';
import { StyledDialog, StyledDialogContent, StyledDialogTitle } from '../../../atoms/styledModal';
import { updateGroupsInCompany } from '../../../../api/group-setting';
import GroupRoleEnum from '../../../../enums/GroupRoleEnum';
import UserAccessItem from '../UserAccessItem/UserAccessItem';
import DialogContentHeader from 'components/atoms/styledModal/DialogContentHeader';
import DialogActionFooter from 'components/molecules/dailog/DialogActionFooter';
import AddGroupMembersDropdown from './AddGroupMembersDropdown';
import { useUserDetialsContext } from 'context/user-details';

function AddManageGroupMembersModal({
  open,
  onClose,
  companyMembers,
  group,
  onUpdateGroupSuccess
}) {
  const [groupDetails, setGroupDetails] = useState(group);
  const [loading, setLoading] = useState(false);
  const {
    userDetails: { user_id: currentUserId }
  } = useUserDetialsContext();
  const handleUpdateGroup = async () => {
    setLoading(true);
    try {
      const response = await updateGroupsInCompany(groupDetails);
      toast.success(response?.data?.message);
      onUpdateGroupSuccess?.(response.data);
      onClose();
    } catch (error) {
      const { error: errorMsg = '', message = '' } = error?.response?.data || {};
      toast.error(errorMsg || message);
    } finally {
      setLoading(false);
    }
  };

  const handleRoleChange = (index, newRole) => {
    setGroupDetails((prev) => {
      const updatedMembers = [...prev.members];
      updatedMembers[index].role = newRole;
      return { ...prev, members: updatedMembers };
    });
  };

  const handleRemoveUser = (index) => {
    setGroupDetails((prev) => {
      const updatedMembers = prev.members.filter((_, i) => i !== index);
      return { ...prev, members: updatedMembers };
    });
  };

  const handleAddMember = (_, selectedUser) => {
    if (!selectedUser?._id) return;

    setGroupDetails((prev) => {
      const memberExists = prev.members.some((member) => member._id === selectedUser._id);
      if (memberExists) return prev;

      const newMember = {
        _id: selectedUser._id,
        name: selectedUser.name,
        email: selectedUser.email,
        role: GroupRoleEnum.GROUP_MEMBER
      };

      return { ...prev, members: [...prev.members, newMember] };
    });
  };
  const Title = group?.is_owner ? 'Add/Manage' : 'View';

  return (
    <StyledDialog open={open} onClose={onClose} maxWidth="xs" fullWidth>
      <StyledDialogTitle>{Title} members</StyledDialogTitle>
      <StyledDialogContent>
        {group?.is_owner && (
          <AddGroupMembersDropdown
            handleAddMember={handleAddMember}
            companyMembers={companyMembers}
          />
        )}
        <DialogContentHeader>People with access</DialogContentHeader>

        {groupDetails?.members?.map((user, index) => {
          const accessPolicyUserId = user?._id;
          const isUserOwnAccessPolicy = Boolean(accessPolicyUserId === currentUserId);
          return (
            <UserAccessItem
              key={user._id}
              user={user}
              index={index}
              handleRoleChange={handleRoleChange}
              handleRemoveUser={handleRemoveUser}
              disabled={!group?.is_owner || isUserOwnAccessPolicy}
            />
          );
        })}
      </StyledDialogContent>
      {group?.is_owner && (
        <DialogActionFooter
          onCancel={onClose}
          onConfirm={handleUpdateGroup}
          isConfirming={loading}
          disabled={loading}
        />
      )}
    </StyledDialog>
  );
}

export default AddManageGroupMembersModal;
